// 관리자 페이지 접근 가능 역할
export const ADMIN_ROLES = ['owner', 'admin', 'admin_learner']

// 학습자 페이지 접근 가능 역할
export const LEARNER_ROLES = ['owner', 'admin_learner', 'manager', 'teacher', 'member']

// 모드 전환 가능 역할 (듀얼 역할)
export const DUAL_ROLES = ['owner', 'admin_learner']

export const canAccessAdmin = (role?: string): boolean =>
  role ? ADMIN_ROLES.includes(role.toLowerCase()) : false

export const canAccessLearner = (role?: string): boolean =>
  role ? LEARNER_ROLES.includes(role.toLowerCase()) : false

export const isDualRole = (role?: string): boolean =>
  role ? DUAL_ROLES.includes(role.toLowerCase()) : false

export type ViewMode = 'admin' | 'learner'
